import { useAppContext } from "context";
import { useTranslation } from "react-i18next";
import {
  Gender,
  TimePeriods,
  SaleReportTypes,
  SaleMeasureTypes,
  ProdRetType,
  InvCountTypes,
  PrintType,
  ProdType,
  SalesType,
  AccBalTypes,
  TxnTypes,
  PeriodicType,
  Role,
  SkuTypes,
  Status,
  PayMethod,
  Healths,
  MemberStatus,
  PaymentMethods,
  ReturnReason,
  ReceiptType,
  PriceTypes,
  PosTemplate,
} from "../constants/dropdowns";

export default function DropLi() {
  const { settings } = useAppContext();
  const { t } = useTranslation("dropdowns");

  const tr = (list, prefix) =>
    list.map((item) => ({
      ...item,
      label: t(`${prefix}_${item.id}`),
      ...(item.subtitle ? { subtitle: t(`${prefix}_${item.id}_sub`) } : {}),
    }));

  const DiscountTypes = [
    { id: 1, label: "%" },
    { id: 2, label: `${settings?.currSymbol || "$"}` },
  ];

  return {
    TimePeriods: tr(TimePeriods, "timePeriod"),
    SaleMeasureTypes: tr(SaleMeasureTypes, "saleMeasureType"),
    SaleReportTypes: tr(SaleReportTypes, "saleReportType"),
    InvCountTypes: tr(InvCountTypes, "invCountType"),
    SkuTypes: tr(SkuTypes, "skuType"),
    MemberStatus: tr(MemberStatus, "memberStatus"),
    PaymentMethods: tr(PaymentMethods, "paymentMethod"),
    Gender: tr(Gender, "gender"),
    Status: tr(Status, "status"),
    Healths: tr(Healths, "health"),
    Role: tr(Role, "role"),
    PayMethod: tr(PayMethod, "payMethod"),
    PeriodicType: tr(PeriodicType, "periodicType"),
    AccBalTypes: tr(AccBalTypes, "accBalType"),
    SalesType: tr(SalesType, "salesType"),
    TxnTypes: tr(TxnTypes, "txnType"),
    ProdRetType: tr(ProdRetType, "prodRetType"),
    ProdType: tr(ProdType, "prodType"),
    DiscountTypes,
    ReturnReason: tr(ReturnReason, "returnReason"),
    PrintType: tr(PrintType, "printType"),
    ReceiptType: tr(ReceiptType, "receiptType"),
    PriceTypes: tr(PriceTypes, "priceType"),
    PosTemplate: tr(PosTemplate, "posTemplate"),
  };
}
